/**
 * Generate an 8-character alphanumeric password
 * @returns {string} 8-character password with letters and numbers
 */
export const generatePublicAccessCode = (): string => {
  const chars = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
  let result = '';
  for (let i = 0; i < 8; i++) {
    result += chars.charAt(Math.floor(Math.random() * chars.length));
  }
  return result;
};

/**
 * Generate a secure public access link for case details
 * @param caseId - The ID of the case
 * @param firmId - The ID of the firm
 * @param accessCode - The generated access code
 * @returns {string} Full public access URL
 */
export const generatePublicAccessLink = (caseId: number, firmId: number, accessCode: string): string => {
  const baseUrl = window.location.origin;
  return `${baseUrl}/public/case/${caseId}/${firmId}/${accessCode}`;
};
